

































import { Component, Prop, Vue } from 'vue-property-decorator';
// import { getModule } from 'vuex-module-decorators';
// import Viewpoints from '@/store/modules/Viewpoints';
// import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
// import Decisions from '@/store/modules/Decisions';
// import Scoring from '@/store/modules/Scoring';

// const viewpointsModule = getModule(Viewpoints);
// const workspaceOptionsModule = getModule(WorkspaceOptions);
// const decisionsModule = getModule(Decisions);
// const scoringModule = getModule(Scoring);

@Component({
    components: {},
})

export default class UiSettingMenu extends Vue {

    @Prop({ type: Number, required: true })
    nodeId: number;

    private menu: boolean = false;

}
